module.exports = __webpack_public_path__ + "facebook-ef97cef8.webp";